import React from "react";
import { connect } from "react-redux";
import "../../../../../styles/components/cotizaciones.scss";

import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";
import { loadTabs } from "../../../../Header/actions";
import { Button } from "devextreme-react";
import { showHideFormCotizaciones } from "./actions";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import StepsPanel from "./StepsPanel";

const Steps = (props) => [
  <Step1 {...props} />,
  <Step2 {...props} />,
  <Step3 {...props} />,
];

class FormNuevaCotizacion extends React.PureComponent {
  constructor(props) {
    super(props);
    // This is the one
    this.state = {
      currentStep: 1,
      step1: {},
      step2: {},
      step3: {},
    };

    this.stepProps = {
      updateStepValues: this.updateStepValues,
    };
  }

  handleNewCotizacion = () => {
    this.props.dispatch(showHideFormCotizaciones(false));
  }

  componentDidUpdate = (prevProps) => {
    if (
      (prevProps.userAccessIds === null &&
        Array.isArray(this.props.userAccessIds))
      //   ||
      // this.props.currentHeader !== "Cotizaciones "
    ) {
      this.loadTabs();
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  };

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.declaracionCotizacion, this.props.userAccessIds))
      tabs.push({ text: "Declaración", contentId: 1, isActive: true });
    // if (checkAccess(ids.declaracionCotizacion, this.props.userAccessIds))
    //   tabs.push({ text: "Confirmación", contentId: 2 });
    this.props.dispatch(
      loadTabs(
        "Cotizaciones ",
        "",
        tabs,
        tabs.length ? tabs[0].contentId : null
      )
    );
  };

  updateStepValues = (step, values, toPreviousStep = false) => {
    const { currentStep } = this.state;
    const newStep = toPreviousStep ? currentStep - 1 : currentStep + 1;
    this.setState({ [step]: values, currentStep: newStep });
  };

  render() {
    const { dispatch, companyId } = this.props;
    const { currentStep } = this.state;
    return (
      <div
        className="row zero formDenunicas"
        style={{
          position: "fixed",
          width: "100%",
          height: "100%",
          top: 0,
          left: this.props.showHideFormCotizaciones ? 0 : 2000,
          opacity: this.props.showHideFormCotizaciones ? 1 : 0,
          right: 0,
          bottom: 0,
          backgroundColor: "white",
          zIndex: 300,
          display: "flex",
          flexWrap: "nowrap",
        }}
      >
        {this.props.showHideFormCotizaciones && (
          <div className="BtnCloseAlign">
            <Button
              style={{
                borderRadius: "50%",
                background: "#EEEEEE",
              }}
              onClick={() => this.handleNewCotizacion()}
            >
              <i className="material-icons" style={{ fontSize: 20, color: "#8A8A8A", fontWeight: 700 }} > clear </i>
            </Button>
          </div>
        )}
        <div id={"cotizaciones"} style={{width: "100%"}}>
          <StepsPanel currentStep={currentStep} />

          <div id="cotizaciones-forms" style={{overflowY: "auto"}}>
            {
              Steps({
                ...this.stepProps,
                steps: { ...this.state },
                dispatch,
                companyId,
              })[currentStep - 1]
            }
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lastCompletedStep: state.denuncias.lastCompletedStep,
  isLoading: state.denuncias.isLoading,
  steps: state.denuncias.steps,
  activeStep: state.denuncias.activeStep,
  showHideFormCotizaciones: state.cotizaciones.showHideFormCotizaciones,
  isOpenModalBorrador: state.denuncias.isOpenModalBorrador,
  editingDraft: state.denuncias.editingDraft,
  isModified: state.denuncias.isModified,
  preData: state.denuncias.preData,
  companyId: state.global.companyId,
  userData: state.global.userData,
  IdComplaint: state.denuncias.IdComplaint,
  jsonData: state.denuncias.jsonData,

  listaTiposAccidente: state.global.listaTiposAccidente,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormNuevaCotizacion);
